module.exports = __webpack_public_path__ + "img/play_button.bce0449f.png";